"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Dropdown_1 = require("../Dropdown/Dropdown");
var Translate_1 = require("./../../Translate/Translate");
var s = require("./Installments.scss");
var getInstallmentsOptions = function (min, max) {
    var options = [
        {
            id: 1,
            label: Translate_1.translate({ forKey: 'cc.installments.singlePayment' }),
            value: 1,
        },
    ];
    for (var i = Math.max(min, 2); i <= max; i++) {
        options.push({ id: i, value: i, label: i });
    }
    return options;
};
var Installments = function (_a) {
    var installments = _a.installments, onInstallmentsSelect = _a.onInstallmentsSelect;
    return (React.createElement("div", { "data-hook": "cashier-payments-method-installments-dropdown" },
        React.createElement("div", { className: s.installmentsTitle }, Translate_1.translate({ forKey: 'cc.installments.title' })),
        React.createElement(Dropdown_1.default, { defaultOptionId: 1, options: getInstallmentsOptions(installments.minInstallments, installments.maxInstallments), onSelect: onInstallmentsSelect })));
};
exports.default = Installments;
//# sourceMappingURL=Installments.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/components/Fields/Installments/Installments.js
// module id = 154
// module chunks = 0 1